import styled from 'styled-components';

export const StyledLine = styled.div`
    width: calc(100% - 32px);
    height: 1px;
    background: #e2e4e9;
    margin: 0px 16px;
`; 